"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = Close;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Close({
  color,
  size = 1,
  variant = 'solid'
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M21.456 5.414l-2.829-2.828-6.585 6.586-6.586-6.586-2.829 2.828L9.213 12l-6.586 6.586 2.829 2.828 6.586-6.586 6.585 6.586 2.829-2.828L14.87 12z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M20.749 4.707l-1.415-1.414-7.292 7.293-7.293-7.293-1.415 1.414L10.627 12l-7.293 7.293 1.415 1.414 7.293-7.293 7.292 7.293 1.415-1.414L13.456 12z",
    fillColor: color
  }));
}